import { DrawCabinetFrontElement } from './DrawCabinetFrontElement';

export class DrawFrontEmpty extends DrawCabinetFrontElement {
}
